import React, { useEffect } from "react";
import { Tabs, Tab, Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";

import {
  fetchStatus,
  onChangeSettingsActiveTab,
} from "../store/slice/preferenceSlice";
import {
  clearDefaultValues,
  fetchMSBCFields,
  fetchStripeFields,
} from "../store/slice/mappingSlice";
import { getDefaultMappingFields } from "../store/slice/contactSlice";

import { useCmsHook } from "../helpers/cms/cmsHook";
import { cmsConstructor } from "../helpers/cms/cmsConstructor";
import CmsEditBanner from "../helpers/cms/CmsEditBanner";

import ContactWindow from "./ContactWindow";
import InvoiceWindow from "./InvoiceWindow";

function SyncSettings() {
  const tabKeys = Object.freeze({
    contactSync: "contact",
    invoiceSync: "invoice",
  });
  const { setCmsInstance } = useCmsHook();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  // preference state
  const {
    settingsActiveTab,
    isMsbcConnected,
    contactActiveTab,
    invoiceActiveTab,
  } = useSelector((state) => state.preference);
  // contact states
  const { isContactSyncRulesSaved, isContactDefaultMappingsSaved } =
    useSelector((state) => state.contact);
  // invoice states
  const { isInvoiceSyncRulesSaved } = useSelector((state) => state.invoice);
  // mapping states
  const {
    isMappingsSaved: { customer: isContactMappingsSaved },
    isMappingsSaved: { invoice: isInvoiceMappingsSaved },
    stripe: { loading: stripeLoading },
    msbc: { loading: msbcLoading },
  } = useSelector((state) => state.mapping);

  useEffect(() => {
    window.scrollTo(0, 0);
    const account = searchParams.get("account");
    if (account) {
      dispatch(fetchStatus(account));
      dispatch(fetchStripeFields(account));
      dispatch(getDefaultMappingFields(account));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const account = searchParams.get("account");
    if (account && isMsbcConnected) {
      dispatch(fetchMSBCFields(account));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMsbcConnected]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.location.pathname === "/syncsettings") {
      const fetchCmsInstance = async () => {
        const cmsObj = await cmsConstructor();
        setCmsInstance(cmsObj);
      };
      fetchCmsInstance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page-bg-container">
      {window.location.pathname === "/syncsettings" && (
        <div className="d-flex flex-row justify-content-center">
          <CmsEditBanner />
        </div>
      )}
      <div className="page-bg-container pt-5">
        <Container
          style={{
            backgroundColor: "#ffffff",
            paddingLeft: "34px",
            paddingRight: "34px",
          }}
          className="window-bg-container mb-5"
        >
          <Tabs
            defaultActiveKey={tabKeys.contactSync}
            onSelect={(selectedKey) => {
              dispatch(clearDefaultValues());
              dispatch(
                onChangeSettingsActiveTab({
                  selectedTab: selectedKey,
                  contactActiveTab,
                  invoiceActiveTab,
                  isContactSyncRulesSaved,
                  isContactDefaultMappingsSaved,
                  isContactMappingsSaved,
                  isInvoiceSyncRulesSaved,
                  isInvoiceMappingsSaved,
                  stripeLoading,
                  msbcLoading,
                })
              );
            }}
            className="sync-settings-tabs pt-2"
            activeKey={settingsActiveTab}
            style={{ top: `${window.location.pathname !== "/setup" && "0px"}` }}
          >
            <Tab eventKey={tabKeys.contactSync} title="Contacts">
              <ContactWindow />
            </Tab>
            <Tab eventKey={tabKeys.invoiceSync} title="Invoices">
              <InvoiceWindow />
            </Tab>
          </Tabs>
        </Container>
      </div>
    </div>
  );
}

export default SyncSettings;
